import { UnknownAction } from "redux";
import { isKeyboardAction } from "../actions/Keyboard.js";
import { isLinkSelectAction } from "../actions/LinkSelect.js";
import { LinkData, LinkSelect } from "../types/index.js";
import { normalizeLink } from "../utils/utils.js";

const initialState: LinkSelect = {
  id: undefined,
  linkData: {
    url: null,
    pageId: null,
    languageId: null,
    moduleId: null,
    moduleType: null,
  },
  confirmed: false,
};

const setLinkSelect = (
  state: LinkSelect,
  id: string,
  linkData: LinkData,
  confirm: boolean,
): LinkSelect => {
  const { url } = linkData;
  return {
    ...state,
    id,
    linkData: { ...linkData, url: normalizeLink(url) },
    confirmed: confirm,
  };
};

const reducer = (state = initialState, action: UnknownAction): LinkSelect => {
  if (!isKeyboardAction(action) && !isLinkSelectAction(action)) {
    return state;
  }

  switch (action.type) {
    case "SET_LINK_SELECT":
      const { confirm, id, linkData } = action;
      return setLinkSelect(state, id, linkData, confirm);

    case "PRESS_ESCAPE_KEY":
    case "RESET_LINK_SELECT":
      return initialState;

    default:
      return state;
  }
};

export default reducer;
